export default function GooglePlaces(
    l10nService,
    googleMapsService) {

    'ngInject';

    return {
        restrict: 'A',
        scope: {
            latitude: '=',
            longitude: '=',
            address: '=',
            altAddress: '=',
            model: '=ngModel',
        },
        link: function($scope, elm, attrs) {
            elm.attr(
                'placeholder',
                elm.attr('placeholder')
                || l10nService.localize('City, Hotel name, airport') + ' ...'
            );

            elm.bind('keydown keypress', function(event) {
                    if (event.which === 13) {
                        event.preventDefault();
                    }
                });

            elm.bind('click', function(event) {
                    event.preventDefault();
                });

            const maps = googleMapsService.getGoogleMaps();
            const autocomplete = maps.places.Autocomplete(elm[0], {});//eslint-disable-line
            maps.event.addListener(autocomplete, 'place_changed', function() {
                    const place = autocomplete.getPlace();
                    const result = place.address_components;
                    const info = [];
                    let countryCode;
                    let altAddress;

                    for (let i = 0; i < result.length; ++i) {
                        if (result[i].types[0] === 'country') {
                            info.push(result[i].long_name);
                            countryCode = result[i].short_name;
                        } else {
                            if (result[i].types[0] === 'administrative_area_level_1') {
                                info.unshift(result[i].long_name);
                            }
                            if (result[i].types[0] === 'postal_town') {
                                info.unshift(result[i].long_name);
                            }
                        }
                    }

                    info.unshift(place.name);
                    const address = info.join(', ');

                    $scope.latitude = place.geometry.location.lat();
                    $scope.longitude = place.geometry.location.lng();
                    $scope.addressText = address;
                    // Only name:
                    $scope.model = address;

                    if (attrs.altAddress) {
                        info.pop();
                        info.push(countryCode);

                        altAddress = info.join(', ');
                        $scope.altAddress = altAddress;
                    }

                    $scope.$apply();
                }
            );
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/google-places/googlePlaces.directive.js